<script setup lang="ts"></script>

<template>
  <section class="policy">
    <slot></slot>
  </section>
</template>

<style lang="scss">
// non-scoped so we can apply styles to incoming content
.policy {
  h1 {
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 2rem;
  }

  h2 {
    font-size: 1.5rem;
    font-weight: 700;
    margin-top: 4rem;
    margin-bottom: 2rem;
  }

  h3 {
    font-size: 1.25rem;
    font-weight: 700;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }

  h4 {
    font-size: 1rem;
    font-weight: 700;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1rem;
    line-height: 1.5rem;
    word-break: normal;
    overflow-wrap: break-word;
  }

  ul li {
    margin-bottom: 1rem;
  }

  strong {
    font-weight: 700;
  }
}
</style>
